module.exports = {
      id: "visual-story-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#visual-story",
      toString: function () {
        return this.url;
      }
    }